export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_LOADING = "SET_LOADING";
export const RESET_LOADING = "RESET_LOADING";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const RESET_ERROR_MESSAGE = "RESET_ERROR_MESSAGE";
export const SET_SUCCESS_MESSAGE = "SET_SUCCESS_MESSAGE";
export const RESET_SUCCESS_MESSAGE = "RESET_SUCCESS_MESSAGE";

export const GET_ADMIN = "GET_ADMIN";
export const GET_STUDENT = "GET_STUDENT";
export const GET_TEACHER = "GET_TEACHER";
export const GET_SUBJECT = "GET_SUBJECT";
export const CLEAR_ADMIN = "CLEAR_ADMIN";
export const CLEAR_STUDENT = "CLEAR_STUDENT";
export const CLEAR_TEACHER = "CLEAR_TEACHER";
export const CLEAR_SUBJECT = "CLEAR_SUBJECT";

export const GET_ADMINS = "GET_ADMINS";
export const GET_STUDENTS = "GET_STUDENTS";
export const GET_TEACHERS = "GET_TEACHERS";
export const GET_SUBJECTS = "GET_SUBJECTS";
export const CLEAR_ADMINS = "CLEAR_ADMINS";
export const CLEAR_STUDENTS = "CLEAR_STUDENTS";
export const CLEAR_TEACHERS = "CLEAR_TEACHERS";
export const CLEAR_SUBJECTS = "CLEAR_SUBJECTS";
export const CLEAR_ALL_DATA = "CLEAR_ALL_DATA";

export const GET_ADMIN_TO_DELETE = "GET_ADMIN_TO_DELETE";
export const GET_STUDENT_TO_DELETE = "GET_STUDENT_TO_DELETE";
export const GET_TEACHER_TO_DELETE = "GET_TEACHER_TO_DELETE";
export const GET_SUBJECT_TO_DELETE = "GET_SUBJECT_TO_DELETE";
export const CLEAR_ADMIN_TO_DELETE = "CLEAR_ADMIN_TO_DELETE";
export const CLEAR_STUDENT_TO_DELETE = "CLEAR_STUDENT_TO_DELETE";
export const CLEAR_TEACHER_TO_DELETE = "CLEAR_TEACHER_TO_DELETE";
export const CLEAR_SUBJECT_TO_DELETE = "CLEAR_SUBJECT_TO_DELETE";

export const GET_ADMIN_TO_UPDATE = "GET_ADMIN_TO_UPDATE";
export const GET_STUDENT_TO_UPDATE = "GET_STUDENT_TO_UPDATE";
export const GET_TEACHER_TO_UPDATE = "GET_TEACHER_TO_UPDATE";
export const GET_SUBJECT_TO_UPDATE = "GET_SUBJECT_TO_UPDATE";
export const CLEAR_ADMIN_TO_UPDATE = "CLEAR_ADMIN_TO_UPDATE";
export const CLEAR_STUDENT_TO_UPDATE = "CLEAR_STUDENT_TO_UPDATE";
export const CLEAR_TEACHER_TO_UPDATE = "CLEAR_TEACHER_TO_UPDATE";
export const CLEAR_SUBJECT_TO_UPDATE = "CLEAR_SUBJECT_TO_UPDATE";
